<template lang="pug">
.nf
    .desc.col
        label DATA DE EMISSÃO
        | {{form.orientacao_data_emissao}}
    h3.text.center(v-if="modal.erro" v-html="modal.erro")
    h3.text-center(v-else) Dados que devem constar em sua Nota Fiscal. 
    .col
        label VALOR (R$)
        .cpn.row.ac
            b {{form.valor | money}}
            Button(@click="copy('valor')" layout="green-go") {{cop.valor}}
    .col
        label DESCRIÇÂO
        .cpn.row.ac
            b {{form.descricao}}
            Button(@click="copy('descricao')" layout="green-go") {{cop.descricao}}
    .row.dados.js.col-s
        .col.g5.g11-s(v-if="form.cnpj_emissor")
            h5.text-center DADOS EMISSOR
            .col
                label CNPJ
                b {{form.cnpj_emissor.cnpj}}
            .col
                label RAZÂO SOCIAL
                b {{form.cnpj_emissor.razao_social}}
            .col
                label ENDEREÇO
                b 
                    i.text-blue CEP:
                    |  {{form.cnpj_emissor.endereco.cep}}
                b 
                    i.text-blue LOGRADOURO:
                    |  {{form.cnpj_emissor.endereco.logradouro}}, {{form.cnpj_emissor.endereco.numero}}. {{form.cnpj_emissor.endereco.complemento?form.cnpj_emissor.endereco.complemento:''}}
                b 
                    i.text-blue BAIRRO:
                    |   {{form.cnpj_emissor.endereco.bairro}}
                b 
                    i.text-blue CIDADE:
                    |  {{form.cnpj_emissor.endereco.cidade}}
        .col.g5.g11-s(v-if="form.cnpj_tomador")
            h5.text-center DADOS TOMADOR
            .col
                label CNPJ
                b {{form.cnpj_tomador.cnpj}}
            .col
                label RAZÂO SOCIAL
                b {{form.cnpj_tomador.razao_social}}
            .col
                label E-MAIL
                b {{form.cnpj_tomador.email}}
            .col
                label INSCRIÇÃO MUNICIPAL
                b {{form.cnpj_tomador.inscricao_municipal}}
            .col
                label ENDEREÇO
                b 
                    i.text-blue CEP:
                    |  {{form.cnpj_tomador.endereco.cep}}
                b 
                    i.text-blue LOGRADOURO:
                    |  {{form.cnpj_tomador.endereco.logradouro}}, {{form.cnpj_tomador.endereco.numero}}. {{form.cnpj_tomador.endereco.complemento?form.cnpj_tomador.endereco.complemento:''}} 
                b 
                    i.text-blue BAIRRO:
                    |  {{form.cnpj_tomador.endereco.bairro}}
                b 
                    i.text-blue CIDADE:
                    |  {{form.cnpj_tomador.endereco.cidade}}
    br
    Button(@click="modal.file" layout="green-go g12") ENVIAR NOTA

</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";

export default {
    name: "NF",
    components: { Button, Loader },
    props: { modal: Object },
    data() {
        return {
            loader: true,
            form: {},
            cop: {
                valor: "COPIAR",
                descricao: "COPIAR",
            }
        };
    },
    methods: {
        ...mapActions("user", ["DADOS_NF"]),
        copy(t) {
            this.cop[t] = "COPIADO"
            navigator.clipboard.writeText(this.form[t])
        },
        async load() {
            this.loader = true
            await this.DADOS_NF({
                dt_previsao_pagamento: this.modal.dt_previsao_pagamento,
                ciclo_semanal: this.modal.tipo_ciclo == "Semanal",
            }).then(({ data }) => { if (data) this.form = data })
            this.loader = false

        }
    },
    beforeMount() {
        this.load()
    },
    computed: {
        ...mapGetters("user", ["user"])
    }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.nf
    label
        @include label 
    max-width: 666px
    padding: 30px
    .desc
        margin-top: -10px
    h3
        color: $orange
        margin-top: 28px
    h5
        color: $purple
        font-size: 17px
        font-weight: bold
        margin-top: 6px
    .cpn
        margin-top: -4px
        margin-bottom: 22px
        button
            margin-left: 12px
    .text-blue
        font-size: 13px
    .dados
        .g5
            padding: 10px 14px
            background: rgba(black, .1)
            border-radius: 12px
        .col
            margin-bottom: 20px
  
</style>